const locale = require('./accountSubmissions.i18n.json');

/*@ngInject*/
const AccountSubmissionsController = function ($scope, $filter, $timeout, currencyUtil, gridColumnModel, submissionMediator) {

    $scope.i18n = locale;
    $scope.selectedSubmissionIds = [];
    $scope.totalData = {};

    let none = _.get($scope.i18n, 'none'),
        submissionsSelected = _.get($scope.i18n, 'submissionsSelected');

    $scope.getSelectedSubmissionText = function () {
        let prefix = none;
        if ($scope.selectedSubmissionIds.length > 0) {
            prefix = $scope.selectedSubmissionIds.length;
        }
        if ($scope.selectedSubmissionIds.length === 1) {
            submissionsSelected = _.get($scope.i18n, 'submissionSelected');
        } else {
            submissionsSelected = _.get($scope.i18n, 'submissionsSelected');
        }

        return prefix + ' ' + submissionsSelected;
    };

    $scope.onSelectedSubmissionsChanged = _.debounce(function (selectedSubmissionIds) {
        let added = _.difference($scope.selectedSubmissionIds, selectedSubmissionIds),
            removed = _.difference(selectedSubmissionIds, $scope.selectedSubmissionIds);
        if (added.length > 0 || removed.length > 0) {
            $scope.selectedSubmissionIds = selectedSubmissionIds;
            populateTotalData();
        }
    }, 500);

    $scope.doPoliciesExistOnSubmissions = function (doPoliciesExist) {
        $scope.doPoliciesExist = doPoliciesExist;
    };

    $scope.showTotals = function () {
        return !_.isEmpty($scope.totalData);
    };

    function populateTotalData() {
        let unroundedEarnedPremiumTotal = 0;
        $scope.colViewModel = {};
        submissionMediator.loadPoliciesBySubmissionIds($scope.selectedSubmissionIds).then(function (policySummaries) {
            $scope.totalData = {};
            if (policySummaries.length > 0) {
                $scope.totalData = {
                    'totalPremium.total': 0,
                    'earnedPremium.total': 0,
                    numberOfClaims: 0,
                    incurredLosses: 0,
                    lossRatio: 0
                };
                _.each(policySummaries, function (policySummary) {
                    $scope.totalData['totalPremium.total'] += _.round(policySummary.totalPremium.roundedTotal);
                    $scope.totalData['earnedPremium.total'] += _.round(policySummary.earnedPremium.roundedTotal);
                    unroundedEarnedPremiumTotal += policySummary.earnedPremium.total;
                    if (policySummary.numberOfClaims) {
                        $scope.totalData.numberOfClaims += policySummary.numberOfClaims;
                    }
                    if (policySummary.incurredLosses) {
                        $scope.totalData.incurredLosses += policySummary.incurredLosses.amount;
                    }
                });
                let format = currencyUtil.getCurrencyFormat(policySummaries[0].totalPremium.currencyCode);
                if (unroundedEarnedPremiumTotal > 0) {
                    $scope.totalData.lossRatio = _.round(($scope.totalData.incurredLosses / unroundedEarnedPremiumTotal) * 100, 2) + '%';
                }
                $scope.totalData['totalPremium.total'] = $filter('currency')($scope.totalData['totalPremium.total'], format.symbol, 0, format.suffixSymbol, format.customFormat);
                $scope.totalData['earnedPremium.total'] = $filter('currency')($scope.totalData['earnedPremium.total'], format.symbol, 0, format.suffixSymbol, format.customFormat);
                $scope.totalData.incurredLosses = $filter('currency')($scope.totalData.incurredLosses, format.symbol, 0, format.suffixSymbol, format.customFormat);

                gridColumnModel.setColumnPreference('system.submissionPolicyGridColumns');
                $scope.totalData.numberOfClaims = '' + $scope.totalData.numberOfClaims;
                $scope.colViewModel = gridColumnModel.getPoliciesGridColumns();
            }
        })
    }

};

angular.module('gw-um-submission')
    .controller('accountSubmissionsController', AccountSubmissionsController);
